import React from "react"
import { Helmet } from "react-helmet"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
function AdvertReview() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/review/adverts/list",
    },
    paths: [
      {
        label: "Review",
        link: "/review/adverts/list",
      },
      {
        label: "Adverts",
        link: "/review/adverts/list",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Review Advert | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />

          <List />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AdvertReview
